import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import ButtonsBar from "../ButtonsBar/ButtonsBar";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const handleBurgerClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false); // Закрыть меню после клика
    }
  };

  const handleMenuItemClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header__content">
        <div className="header__burger" onClick={handleBurgerClick}>
          <span></span>
          <span></span>
        </div>
        <Link to="/" className="header__logo"></Link>
        {/* <Link to="/" className="header__sign-up">
          Sign up
        </Link> */}

        <nav className={`header__menu ${isMenuOpen ? "menu--open" : ""}`}>
          <button className="header__close-button" onClick={handleBurgerClick}>
            &times;
          </button>
          <div className="menu-buttons">
            <Link
              to="/property-development"
              className="header__menu-link"
              onClick={handleMenuItemClick}
            >
              PROPERTY DEVELOPMENT
            </Link>
            <Link
              to="/construction-materials"
              className="header__menu-link"
              onClick={handleMenuItemClick}
            >
              CONSTRUCTION MATERIALS
            </Link>

            <Link
              to="/investment-opportnites"
              className="header__menu-link"
              onClick={handleMenuItemClick}
            >
              INVESTMENT OPPORTNITES
            </Link>
            <Link
              to="/gallery"
              className="header__menu-link"
              onClick={handleMenuItemClick}
            >
              GALLERY
            </Link>
            <Link className="header__menu-link" onClick={handleMenuItemClick}>
              GET IN TOUCH
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
